<kendo-dropdownbutton [data]="userActions" [popupSettings]="{popupClass: 'user-box', animate: true}">
    <div class="avatar">
        <i class='bx bxs-user-circle'></i>
    </div>
</kendo-dropdownbutton>

<div class="info">
    <span>
        <span class="login-as" *ngIf="user?.impersonated">Zalogowany jako:</span>
        <span class="name" *ngIf="user?.email">
            {{user?.name}}
            <span class="email">
                {{user?.email}}
            </span>
        </span>
    </span>
</div>

